const fns = {};
export default fns;
